import { render, staticRenderFns } from "./ProofOfDeliveryTemplateList.vue?vue&type=template&id=461ec8dc&scoped=true&"
import script from "./ProofOfDeliveryTemplateList.vue?vue&type=script&lang=js&"
export * from "./ProofOfDeliveryTemplateList.vue?vue&type=script&lang=js&"
import style0 from "./ProofOfDeliveryTemplateList.vue?vue&type=style&index=0&id=461ec8dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461ec8dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('461ec8dc')) {
      api.createRecord('461ec8dc', component.options)
    } else {
      api.reload('461ec8dc', component.options)
    }
    module.hot.accept("./ProofOfDeliveryTemplateList.vue?vue&type=template&id=461ec8dc&scoped=true&", function () {
      api.rerender('461ec8dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/ProofOfDelivery/ProofOfDeliveryTemplateList.vue"
export default component.exports